module.exports = __webpack_public_path__ + "static/media/CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4.0d6191be.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4
// module id = 601
// module chunks = 0